import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

// 1) Ensure the Assistant account exists in localStorage:
const initialUsers = JSON.parse(localStorage.getItem("users")) || [];

// Check if the assistant account is already present
const assistantExists = initialUsers.some((u) => u.accountName === "AA123");

if (!assistantExists) {
  initialUsers.push({
    firstName: "Assist",
    lastName: "Helper",
    accountName: "koalaquestcanada@gmail.ca",
    password: "137AB2Cd!",
    birthDate: "N/A",
    parentCode: "N/A",
    accountType: "Assistant",
    coins: 0,
  });
  localStorage.setItem("users", JSON.stringify(initialUsers));
}

// 2) Then proceed with your normal rendering
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <App />
    </BrowserRouter>
    
  </React.StrictMode>
);

reportWebVitals();
